import React from 'react';
import { useSelector } from 'react-redux';
import { reduxForm, Field } from 'redux-form/immutable';
import { Button, Grid, Typography } from '@material-ui/core';

import Box from 'retired/Box';
import FormFileUpload from 'retired/FormFileUpload';
import FormFieldLabel from 'retired/FormFieldLabel';
import { ViewInAppButton } from 'components/ViewInAppButton';
import { selectOrganization } from 'entities/user/selectors';
import { getAppDomain } from 'utils/getAppDomain';

import { SplashImageData } from './actions';
import { SPLASH_IMAGE_FORM_IDENTIFIER as FORM_IDENTIFIER } from './constants';

const withForm = reduxForm<SplashImageData>({
  form: FORM_IDENTIFIER,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
});

interface SplashImageFormProps {
  submitting: boolean;
  invalid: boolean;
  pristine: boolean;
  handleSubmit: (
    event: (data: { toJS(): SplashImageData }) => void
  ) => ((event: React.FormEvent<HTMLFormElement>) => void) | undefined;
  submitForm: (data: SplashImageData) => void;
}

const SplashImageForm = withForm(
  ({ submitting, handleSubmit, submitForm }: SplashImageFormProps) => {
    const organization = useSelector(selectOrganization);
    if (!organization?.sso && !organization?.sso2) {
      return null;
    }

    return (
      <form onSubmit={handleSubmit((data) => submitForm(data.toJS()))}>
        <fieldset>
          <Box style={{ paddingTop: 0, marginBottom: 30 }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
              }}
            >
              <h2>Background Image for Login Splash Screen</h2>
              <ViewInAppButton
                href={getAppDomain([organization])}
                title="Make sure to be logged off to see the login splash screen!"
                iconSize={18}
                style={{
                  display: 'inline-block',
                  marginRight: 30,
                  marginTop: 25,
                }}
              />
            </div>
            <Grid container spacing={4}>
              <Grid item xs={12} lg={8} xl={9}>
                <FormFieldLabel forName="splashBackgroundImage">
                  Upload an image for your login splash screen.
                </FormFieldLabel>
                <Field
                  id="splashBackgroundImage"
                  name="splashBackgroundImage"
                  component={FormFileUpload}
                  labelText={`This image will be displayed as the background on the login splash screen. If no image
                  is provided, then the background will be the solid brand color set for your
                  company on the "Company Profile" page. Make sure that the image format is a JPG.`}
                  acceptedTypes="image/jpeg"
                  maxSize={1024 * 1024 * 10}
                  imagePreview
                  withCrop
                  cropRatio={1920 / 1280}
                  fixed
                  allowClear
                />
              </Grid>
            </Grid>

            <Typography align="right">
              <Button type="submit" variant="contained" color="primary" disabled={submitting}>
                Submit
              </Button>
            </Typography>
          </Box>
        </fieldset>
      </form>
    );
  }
);

export default SplashImageForm;
